<template>
    <b-card-body>  
        <b-card-title v-if="ShowTitle" class="font-weight-semibold">
            {{ News.Title }}
        </b-card-title>                          
        <b-card-text v-html="News.Message" />
    </b-card-body>
</template>

<script lang="ts">
    import Component from 'vue-class-component';
    import NewsNotification from '@/types/NewsNotification';
    import { Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class NewsContent extends Vue {
        @Prop({ default : () => {}})
        public News : NewsNotification;

        /** Permet d'afficher le titre de la news (utilisé dans le cas du centre de notifications) */
        @Prop({ default : () => false})
        public ShowTitle!: boolean;
    }
</script>

<style></style>